// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderPage_header__3QhZN","title":"HeaderPage_title___beFM"};